import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            waldmeierKlassen: null,
            waldMeierKlasse: null,
            mcIntoschKlassen: null,
            mcItoschKlasse: null
        }
    },
    mutations: {
        setKlassen(state, klassen) {
            state.waldmeierKlassen = klassen
        },
        setKlasse(state, klasse) {
            state.waldMeierKlasse = klasse
        },
        setMcItoschKlassen(state, klassen) {
            state.mcIntoschKlassen = klassen
        },
        setMcIntoschKlasse(state, klasse) {
            state.mcItoschKlasse = klasse
        }
    },
    actions: {
        fetchWaldmeierKlassen({commit}) {
            axiosInstance.get("/zon/vasteData")
                .then(result => commit('setKlassen', result.data))
        },
        fetchMcItoschklassen({commit}) {
            axiosInstance.get("/zon/vasteData/McIntosch")
                .then(result => commit('setMcItoschKlassen', result.data))
        }
    }
}